import Vue from 'vue';
import Buefy from 'buefy';
import VueResource from 'vue-resource';

// import 'buefy/lib/buefy.css'
import "bulma/sass/base/minireset.sass";
import "bulma/sass/elements/_all.sass";
import "bulma/sass/components/_all.sass";
import "bulma/sass/utilities/_all.sass";

Vue.use(Buefy);
Vue.use(VueResource);

import Form from './form.vue'
import Button from './button.vue'
var eventHub = new Vue() // Single event hub

Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub
    }
  }
})
new Vue({
  el: '#app',
  components: {'sms-form': Form}
})

new Vue({
  el: '#app-button',
  components: {'app-button': Button}
})



// WEBPACK FOOTER //
// ./src/main.js